import type * as React from "react";

import { cx } from "../../lib/cx";
import s from "./KeyValueList.module.css";

export interface KeyValueListProps extends React.ComponentPropsWithoutRef<"dl"> {
  /** `bordered`: hairline entre filas dentro de un marco. `plain`: filas sueltas. */
  tone?: "bordered" | "plain";
  /** Clave y valor en columnas (default) o apilados. */
  layout?: "columns" | "stacked";
}

/** Lista de pares clave/valor: la ficha de la propiedad, los datos de una visita, el resumen de un turno. */
export function KeyValueList({ tone = "bordered", layout = "columns", className, children, ...rest }: KeyValueListProps) {
  return (
    <dl className={cx(s.lista, className)} data-tone={tone} data-layout={layout} {...rest}>
      {children}
    </dl>
  );
}

export interface KeyValueProps extends React.ComponentPropsWithoutRef<"div"> {
  label: React.ReactNode;
  /** Cifras, códigos y fechas con tabular-nums. */
  mono?: boolean;
}

export function KeyValue({ label, mono = false, className, children, ...rest }: KeyValueProps) {
  return (
    <div className={cx(s.fila, className)} {...rest}>
      <dt className={s.clave}>{label}</dt>
      <dd className={s.valor} data-mono={mono || undefined}>
        {children}
      </dd>
    </div>
  );
}
